var _defs, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #828282;\n      }\n\n      .st1 {\n        isolation: isolate;\n      }\n\n      .st2 {\n        fill: #fff;\n      }\n\n      .st3 {\n        fill: none;\n        stroke: #707070;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_153581"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    width: 98,
    height: 102,
    rx: 4,
    ry: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 0.5,
    y: 0.5,
    width: 97,
    height: 101,
    rx: 3.5,
    ry: 3.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64439",
    className: "st0",
    d: "M28.3,40.2l7.7,7.7c.7.8,2,.8,2.7,0s.8-2,0-2.7c0,0,0,0,0,0l-6.4-6.4,6.4-6.4c.8-.8.8-2,0-2.7-.8-.8-2-.8-2.7,0h0l-7.7,7.7c-.8.8-.8,2,0,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64440",
    className: "st0",
    d: "M62,29.8c-.7-.8-2-.8-2.7,0s-.8,2,0,2.7c0,0,0,0,0,0l6.4,6.4-6.4,6.4c-.8.7-.8,2-.1,2.7s2,.8,2.7.1c0,0,0,0,.1-.1l7.7-7.7c.8-.8.8-2,0-2.7l-7.7-7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64441",
    className: "st0",
    d: "M51,24.8l-7.7,27.1c-.3,1,.3,2.1,1.3,2.4.2,0,.4,0,.5,0,.9,0,1.6-.6,1.9-1.4l7.7-27.1c.3-1-.2-2.1-1.2-2.4-1-.3-2.1.2-2.4,1.2,0,0,0,0,0,.1Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Two",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.7,84h3.2v1h-4.5v-7.1h1.2v6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.6,82.3c0-.5.1-1,.3-1.4.2-.4.5-.7.9-1,.4-.2.8-.3,1.3-.3.7,0,1.3.2,1.7.7s.7,1.1.7,1.8v.3c0,.5,0,1-.3,1.4s-.5.7-.9,1c-.4.2-.8.3-1.3.3-.7,0-1.3-.2-1.8-.7-.4-.5-.7-1.2-.7-2h0ZM44.8,82.4c0,.5.1,1,.3,1.3.2.3.5.5.9.5s.7-.2.9-.5c.2-.3.3-.8.3-1.4s-.1-1-.3-1.3-.5-.5-.9-.5-.7.2-.9.5c-.2.3-.3.8-.3,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.3,82.3c0-.5.1-1,.3-1.4.2-.4.5-.7.9-1,.4-.2.8-.3,1.3-.3.7,0,1.3.2,1.7.7s.7,1.1.7,1.8v.3c0,.5,0,1-.3,1.4s-.5.7-.9,1c-.4.2-.8.3-1.3.3-.7,0-1.3-.2-1.8-.7-.4-.5-.7-1.2-.7-2h0ZM50.5,82.4c0,.5.1,1,.3,1.3.2.3.5.5.9.5s.7-.2.9-.5c.2-.3.3-.8.3-1.4s-.1-1-.3-1.3-.5-.5-.9-.5-.7.2-.9.5c-.2.3-.3.8-.3,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.8,82.4c0,.8-.2,1.5-.6,2-.4.5-.9.7-1.5.7s-1-.2-1.4-.6v2.5h-1.2v-7.3h1.1v.5c.4-.4.9-.6,1.5-.6s1.1.2,1.5.7c.4.5.5,1.1.5,2h0ZM58.6,82.3c0-.5-.1-.9-.3-1.3s-.5-.5-.9-.5-.8.2-1,.6v2.3c.2.4.6.6,1.1.6s.7-.2.9-.5c.2-.3.3-.8.3-1.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoop);
export default __webpack_public_path__ + "static/media/Loop.082a0a00915bba849b7da1697dc445bb.svg";
export { ForwardRef as ReactComponent };